//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import PartnerCenterBaseClient from './partnerCenterBaseClient';
import ProblemDetails from './problemDetails';

export class AppClient extends PartnerCenterBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getClientConfig(): Promise<ClientConfigResponse> {
        let url_ = this.baseUrl + "/api/app/client-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClientConfig(_response));
        });
    }

    protected processGetClientConfig(response: Response): Promise<ClientConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientConfigResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientConfigResponse>(null as any);
    }
}

export class PointInstanceClient extends PartnerCenterBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    ensureApplicationCertificate(pointInstanceId: string): Promise<string> {
        let url_ = this.baseUrl + "/api/point-instances/{pointInstanceId}/ensure-application-certificate";
        if (pointInstanceId === undefined || pointInstanceId === null)
            throw new Error("The parameter 'pointInstanceId' must be defined.");
        url_ = url_.replace("{pointInstanceId}", encodeURIComponent("" + pointInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEnsureApplicationCertificate(_response));
        });
    }

    protected processEnsureApplicationCertificate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    setEntraApplicationIds(pointInstanceId: string, setPointInstanceEntraApplicationIdsRequest: SetPointInstanceEntraApplicationIdsRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/point-instances/{pointInstanceId}/set-entra-application-ids";
        if (pointInstanceId === undefined || pointInstanceId === null)
            throw new Error("The parameter 'pointInstanceId' must be defined.");
        url_ = url_.replace("{pointInstanceId}", encodeURIComponent("" + pointInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setPointInstanceEntraApplicationIdsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetEntraApplicationIds(_response));
        });
    }

    protected processSetEntraApplicationIds(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PartnerOrganizationClient extends PartnerCenterBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDashboardPointInstances(): Promise<DashboardPointInstancesResponse> {
        let url_ = this.baseUrl + "/api/partner-organizations/dashboard-point-instances";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDashboardPointInstances(_response));
        });
    }

    protected processGetDashboardPointInstances(response: Response): Promise<DashboardPointInstancesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardPointInstancesResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardPointInstancesResponse>(null as any);
    }
}

export class OneTimePasswordClient extends PartnerCenterBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(createOneTimePasswordRequest: CreateOneTimePasswordRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/one-time-passwords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createOneTimePasswordRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    validate(validateOneTimePasswordRequest: ValidateOneTimePasswordRequest): Promise<ValidateOneTimePasswordResponse> {
        let url_ = this.baseUrl + "/api/one-time-passwords/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(validateOneTimePasswordRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidate(_response));
        });
    }

    protected processValidate(response: Response): Promise<ValidateOneTimePasswordResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidateOneTimePasswordResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateOneTimePasswordResponse>(null as any);
    }

    byInstanceId(instanceId: string): Promise<GetOTPResponse> {
        let url_ = this.baseUrl + "/api/one-time-passwords/instance/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processByInstanceId(_response));
        });
    }

    protected processByInstanceId(response: Response): Promise<GetOTPResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOTPResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOTPResponse>(null as any);
    }
}

export interface ClientConfigResponse {
    clientId: string;
    instanceUrl: string;
    b2CDomain: string;
    signInPolicy: string;
    applicationInsights: ApplicationInsightsOptions;
    production: boolean;
}

export interface ApplicationInsightsOptions {
    appId: string;
    connectionString: string;
    enableDependencyTrackingTelemetryModule: boolean;
}

export interface SetPointInstanceEntraApplicationIdsRequest {
    entraApplicationId: string;
    pointApiEntraApplicationId: string;
}

export interface DashboardPointInstancesResponse {
    pointInstances: DashboardPointInstance[];
}

export interface DashboardPointInstance {
    id: string;
    status: PointInstanceStatus;
    connectionStatus: PointInstanceConnectionStatus;
    name: string;
    url: string;
    licenseData?: DashboardPointInstanceLicenseData | undefined;
}

export enum PointInstanceStatus {
    OK = 1,
    Error = 2,
}

export enum PointInstanceConnectionStatus {
    PendingPartnerOrganizationConnection = 1,
    PendingCertificateCreation = 2,
    PendingEntraApplicationIds = 3,
    Connected = 4,
}

export interface DashboardPointInstanceLicenseData {
    plan: string;
    validUntil: Date;
    totalUsers: number;
    licensedUsers: number;
}

export interface CreateOneTimePasswordRequest {
    url: string;
}

export interface ValidateOneTimePasswordResponse {
    pointInstanceId?: string | undefined;
    partnerOrganizationName?: string | undefined;
    errorMessage?: string | undefined;
    isValid: boolean;
}

export interface ValidateOneTimePasswordRequest {
    tenantId: string;
    oneTimePasswordKey: string;
}

export interface GetOTPResponse {
    value: string;
    isValid: boolean;
    errorMessage?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export interface ApiException {
    problemDetails: ProblemDetails;
}